import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { faTimes, faMapMarker, faPen, faPhone, faComment, faInfo, faStar, faChevronRight, faChevronLeft, faChevronDown, faPhotoVideo, faHandshake, faEnvelope, faCalendar, faBuilding, faQuoteLeft, faCheckDouble, faClock, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { Business } from 'backend/interfaces/business.interface';
import { AuthService } from 'src/app/auth/auth.service';
import { BusinessDataService } from 'src/app/business/services/data.service';
import { DataService } from 'src/app/services/data.service';
import { ReviewDialogComponent } from '../review-dialog/review-dialog.component';
import { StarRatingColor } from '../components/star-rating/star-rating.component';
import { MatTabGroup } from '@angular/material/tabs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppointmentService } from 'src/app/services/appointment.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BusinessAppointmentComponent } from '../business-appointment/business-appointment.component';
import { BusinessService } from 'src/app/admin/services/business.service';
@Component({
  selector: 'app-view-business',
  templateUrl: './view-business.component.html',
  styleUrls: ['./view-business.component.scss']
})
export class ViewBusinessComponent implements OnInit {

  constructor(private dataService: DataService, private router: Router, private ar: ActivatedRoute, private businessDataService: BusinessDataService, private authService: AuthService, private dialog: MatDialog, private fb: FormBuilder, private appointmentService: AppointmentService, private _snackBar: MatSnackBar, private businessService: BusinessService) {
  }

  faTimes = faTimes;
  faPin = faMapMarker;
  faPen = faPen;
  faPhone = faPhone;
  faComment = faComment;
  faInfo = faInfo;
  faStar = faStar;
  faNext = faChevronRight;
  faPrev = faChevronLeft;
  faDown = faChevronDown;
  faPhoto = faPhotoVideo;
  faShake = faHandshake;
  faClock = faClock;
  faEnvelope = faEnvelope;
  faCalendar = faCalendar;
  faBuilding = faBuilding;
  faQuoteLeft = faQuoteLeft;
  faCheckList = faCheckDouble;
  faGlobe = faGlobe;
  starColor: StarRatingColor = StarRatingColor.accent;
  starColorP: StarRatingColor = StarRatingColor.primary;
  starColorW: StarRatingColor = StarRatingColor.warn;
  ads = [];
  loading = false;
  isFavorite = false;
  updatingFavorite = false;
  business: Business;
  businessName;
  loggedIn = false;
  averageRating = 3;
  rating = 0;
  ratings = [{ score: 0, comment: '' }];
  reviews = []
  today = new Date().toLocaleDateString('en-ZA', { weekday: 'long' });;
  makingAppointment = false;
  minDate = new Date();
  currentTime = new Date().toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit', hour12: false });
  @ViewChild('tabs') tabs: MatTabGroup
  async ngOnInit(): Promise<void> {
    this.loggedIn = this.authService.isAuthenticated() !== null;
    this.loading = true;
    this.businessName = this.ar.snapshot.params['name'];
    // this.dataService.business$.subscribe(res => {
    //   if(res){
    //   this.business = res;
    //   this.getReviews();
    //   this.getAds();
    //   this.loading = false;
    //   }else{
    const cachedBusiness = this.dataService.business.value;
    this.dataService.getBusinessByName(this.businessName).then(async res => {
      this.business = cachedBusiness?.Name === this.businessName
        ? { ...res, ...cachedBusiness }
        : res;

      // The authenticated endpoint includes workflow fields such as Status.
      if (this.loggedIn && this.business?.id) {
        try {
          const ownerBusiness = await this.businessService.getBusinessById(this.business.id);
          if (ownerBusiness) this.business = { ...this.business, ...ownerBusiness };
        } catch (err) {
          console.error('Unable to load owner business status:', err);
        }
      }
      this.getReviews();
      this.getAds();
      if (this.business) {
        this.authService.$User.subscribe(res => {
          const favorites = res?.get('Favorites') || [];
          this.isFavorite = favorites.includes(this.business.id);
        })
      }
      this.loading = false;
    });
    //   }
    // })
  }

  favouriteBusiness(business: any) {
    if (!this.requireLogin()) return;
    this.updatingFavorite = true;
    this.dataService.favoriteBusiness(business.id).then(async res => {
      this.isFavorite = true;
      await this.businessDataService.getUserFavorites(res).then(res => {
        this.businessDataService.favorites.next(res);
      })
    }).catch(err => console.log(err)).finally(() => {
      this.updatingFavorite = false;
    });
  }

  unFavouriteBusiness(id: string) {
    if (!this.requireLogin()) return;
    this.updatingFavorite = true;
    this.dataService.unFavoriteBusiness(id).then(async (res) => {
      this.isFavorite = false;
      await this.businessDataService.getUserFavorites(res).then(res => {
        this.businessDataService.favorites.next(res);
      })
    }).catch(err => console.log(err)).finally(() => {
      this.updatingFavorite = false;
    });
  }

  private requireLogin(): boolean {
    if (this.authService.isAuthenticated()) return true;
    this.router.navigate(['auth', 'login'], { queryParams: { returnUrl: this.router.url } });
    return false;
  }

  back(): void {
    const prevUrl = this.dataService.getPreviousUrl();
    if (prevUrl === this.router.url) {
      this.router.navigateByUrl('category/' + this.business.Category.id);
    } else {
      this.router.navigateByUrl(prevUrl);
    }
  }

  createAppointment(business: any): void {
    console.log(business)
    const dialogRef = this.dialog.open(BusinessAppointmentComponent, {
      data: { business: business },
      width: '60%'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  createReview(src?: any): void {
    const dialogRef = this.dialog.open(ReviewDialogComponent, {
      data: { title: '', comment: '', business: this.business },
      width: '60%'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  getReviews() {
    this.businessDataService.getReviewsByBusinessId(this.business.id).then(res => {
      this.reviews = res;
      let total = 0;
      res.forEach(element => {
        if (element.Rating)
          total += element.Rating;
        this.averageRating = Math.round(total / res.length);
      });

    }).catch(err => console.log(err))
  }

  viewReviews() {
    this.tabs.selectedIndex = 2;
  }

  async getAds(): Promise<void> {
    await this.businessDataService.getAdsByBusinessId(this.business.id);
    this.businessDataService.ads$.subscribe(res => this.ads = res);
  }

  signUp() {
    this.router.navigate(['auth', 'register'], { queryParams: { returnUrl: this.router.url } })
  }

  chatOnWhatsApp(mobile: string) {
    let cleaned_number = mobile.replace(/^[0\s+]+/, "");
    console.log(cleaned_number);
    window.open("https://wa.me/" + "27" + cleaned_number, "_blank");
  }

  async copyLink(): Promise<void> {
    try {
      await this.copyText(this.getShareUrl());
      this._snackBar.open('Link copied to clipboard!', 'OK', { duration: 3000 });
    } catch (err) {
      console.error('Failed to copy link:', err);
      this._snackBar.open('Unable to copy the link.', 'OK', { duration: 3000 });
    }
  }

  shareViaWhatsApp(): void {
    const text = `Check out ${this.business.Name} on ADVIBE: ${this.getShareUrl()}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
  }

  private getShareUrl(): string {
    return `${window.location.origin}/business/${encodeURIComponent(this.business.Name)}`;
  }

  private async copyText(text: string): Promise<void> {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    const input = document.createElement('textarea');
    input.value = text;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.focus();
    input.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(input);
    if (!copied) throw new Error('Clipboard copy was rejected');
  }

  compareTime(currentTime, endTime, startTime): string {
    const parts1 = endTime.split(':').map(Number); // [10, 30]
    const parts2 = currentTime.split(':').map(Number); // [11, 45]
    const parts3 = startTime.split(':').map(Number); // [08, 00]


    if (parts2[0] <= parts1[0] && parts2[0] >= parts3[0]) { // Compare hours
      return 'Open'
    } else if (parts2[0] > parts1[0] || parts2[0] <= parts3[0]) {
      return 'Closed'
    } else {
      // Hours are equal, compare minutes
      if (parts2[1] <= parts1[1] && parts2[1] >= parts3[1]) {
        return 'Open'
      } else if (parts2[1] > parts1[1] || parts2[1] <= parts3[1]) {
        return 'Closed'
      } else {
        return 'Closed'
      }
    }
  }
}
